import { useCallback } from 'react';
import { ContentUsageType } from './useGetContentUsage';
import { useGetEntityValues } from '../../screens/EntityDetailsShow/SelectedEntityProvider/useEntityOptions';

const useGetEntityAppLink = ({ entity }: { entity: EntityDetails.Entity }) => {
  const getEntityValues = useGetEntityValues(entity, '');

  const goToEntity = useCallback(
    async ({
      contentItem,
    }: {
      contentItem: { id: string; name: string; type: ContentUsageType };
    }) => {
      const values = await getEntityValues();
      const link = `/entities/${entity.primaryField}/${values[0]}/${contentItem.type}/${contentItem.id}`;
      window.open(link, '_blank');
    },
    [entity.primaryField, getEntityValues],
  );

  return goToEntity;
};

export default useGetEntityAppLink;
